import { useState, useCallback } from 'react';
import gamesService from '../services/gamesService';

interface UseLottoSalesProps {
  storeId: string;
  storeData: any;
  setError: (error: string | null) => void;
}

export const useLottoSales = ({ storeId, storeData, setError }: UseLottoSalesProps) => {
  const [lottoSaleDialogOpen, setLottoSaleDialogOpen] = useState(false);
  const [lottoSaleAmount, setLottoSaleAmount] = useState('');
  const [lottoSaleLoading, setLottoSaleLoading] = useState(false);

  const handleLottoSale = useCallback(() => {
    setLottoSaleDialogOpen(true);
    setLottoSaleAmount('');
  }, []);

  const handleLottoSaleSubmit = useCallback(async () => {
    if (!lottoSaleAmount || parseFloat(lottoSaleAmount) <= 0) return;

    setLottoSaleLoading(true);
    setError(null);

    const saleAmountValue = parseFloat(lottoSaleAmount);

    try {
      // Get the actual store_key from storeData or use storeId as fallback
      const actualStoreKey = storeData?.store_key || storeId || '';

      // Prepare lotto sale request
      const lottoSaleRequest = {
        store_key: actualStoreKey,
        amount: saleAmountValue,
      };

      const response = await gamesService.processLottoSale(lottoSaleRequest);

      if (response.success) {
        console.log('Lotto sale processed successfully:', response.message);

        // Close the dialog
        setLottoSaleDialogOpen(false);
        setLottoSaleAmount('');
      } else {
        setError(`Failed to process lotto sale: ${response.message}`);
        console.error('Lotto sale failed:', response.message);
      }
    } catch (error) {
      console.error('Error processing lotto sale:', error);
      setError('Failed to process lotto sale. Please try again.');
    } finally {
      setLottoSaleLoading(false);
    }
  }, [lottoSaleAmount, storeData, storeId, setError]);

  const handleLottoSaleCancel = useCallback(() => {
    setLottoSaleDialogOpen(false);
    setLottoSaleAmount('');
  }, []);

  return {
    lottoSaleDialogOpen,
    lottoSaleAmount,
    setLottoSaleAmount,
    lottoSaleLoading,
    handleLottoSale,
    handleLottoSaleSubmit,
    handleLottoSaleCancel,
  };
}; 